(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["byboost-mag-cyber"] && !Shopify.designMode) return;
  try {
    
function initMagCyber(scope){scope.querySelectorAll('[data-bmc]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const gallery=section.querySelector('.bmc__main-image');section.querySelectorAll('.bmc__thumb').forEach(button=>button.addEventListener('click',()=>{if(!gallery)return;gallery.src=button.dataset.image;gallery.srcset=button.dataset.srcset;gallery.alt=button.getAttribute('aria-label');section.querySelectorAll('.bmc__thumb').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));}));const form=section.querySelector('.bmc__form');if(!form)return;form.addEventListener('submit',async event=>{event.preventDefault();const button=form.querySelector('[type=submit]');const error=form.querySelector('.bmc__error');button.disabled=true;error.hidden=true;try{const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});const added=await response.json();if(!response.ok)throw Error(added.description||added.message);const cartResponse=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{headers:{Accept:'application/json'}});const cart=await cartResponse.json();document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart}}));document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{cart}}));if(document.querySelector('kaching-cart')){document.dispatchEvent(new CustomEvent('kaching-cart:open',{detail:{element:button,cartOpenSource:'add-to-cart'}}));}else{window.location.assign((window.Shopify?.routes?.root||'/')+'cart');}}catch(e){error.textContent=e.message;error.hidden=false;}finally{button.disabled=false;}});});}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>initMagCyber(document));}else{initMagCyber(document);}document.addEventListener('shopify:section:load',event=>initMagCyber(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
